export default __webpack_public_path__ + "static/media/netflix.be4a18f7.png";